export const DEFAULT_COUNTRY_CODE = 'SG';
export var ShippingMethodHandler;
(function (ShippingMethodHandler) {
    ShippingMethodHandler["EMPTY"] = "";
    ShippingMethodHandler["DAY_SELECTION"] = "DaysSelectionConfiguration";
})(ShippingMethodHandler || (ShippingMethodHandler = {}));
const DEFAULT_SHIPPING_METHOD = ShippingMethodHandler.EMPTY;
var ShippingMethodComponent;
(function (ShippingMethodComponent) {
    ShippingMethodComponent["EMPTY"] = "ShippingSelect";
    ShippingMethodComponent["DAY_SELECTION"] = "ShippingDaySelect";
})(ShippingMethodComponent || (ShippingMethodComponent = {}));
export const shippingMethodComponent = {
    [ShippingMethodHandler.EMPTY]: ShippingMethodComponent.EMPTY,
    [ShippingMethodHandler.DAY_SELECTION]: ShippingMethodComponent.DAY_SELECTION,
};
export function mapShippingMethod(x) {
    let hasSelection = false;
    if (x.options) {
        x.options?.forEach((option) => {
            if (option.options && option.options?.length > 0) {
                hasSelection = true;
            }
        });
    }
    return {
        component: hasSelection
            ? shippingMethodComponent[ShippingMethodHandler.DAY_SELECTION]
            : shippingMethodComponent[DEFAULT_SHIPPING_METHOD],
        method: hasSelection
            ? ShippingMethodHandler.DAY_SELECTION
            : DEFAULT_SHIPPING_METHOD,
        ...x,
    };
}
export const defaultShippingMetadata = {
    selectedDay: null,
    contactlessDelivery: false,
};
